<template>
  <span>
    <label class="page-label">Restream</label>
    <p style="font-weight: 400px; font-size: 14px; line-height: 21px;">{{ $t('message.pages.live.restreamDescription') }}</p>
    <base-btn
      type="secondary"
      size="small"
      class="ml-auto w-100"
      @click="openRestreamModal"
    >
    {{ $t('message.actions.add') }}
    </base-btn>

    <v-dialog v-model="restreamDialog" max-width="700">
        <v-card v-if="!reStreamLoading && !reStreamError">
          <v-card-title class="text-h5">
            <v-icon class="pr-2" large color="primary">mdi-access-point</v-icon>
            {{ $t('message.pages.newLive.reStream') }}
            <v-spacer></v-spacer>
            <v-btn icon @click="closeModal"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text class="mt-2">
            {{ $t('message.pages.newLive.reStreamDescription') }}
          </v-card-text>
          <v-row class="px-6">
            <v-col cols="4">
              <v-text-field
                v-model="newRestream.rtmp"
                :label="$t('message.pages.newLive.streamUrl')"
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="5">
              <v-text-field
                v-model="newRestream.streamKey"
                :label="$t('message.pages.newLive.streamKey')"
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-row class="px-4 pt-3">
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  :loading="addRestreamLoading"
                  :disabled="
                    addRestreamLoading ||
                    newRestream.rtmp === '' ||
                    newRestream.streamKey === ''
                  "
                  @click="handleAddRestream"
                  >{{ $t('message.pages.newLive.add') }}</v-btn
                >
              </v-row>
            </v-col>
          </v-row>
          <v-col cols="12">
            <v-col
              class="pa-0"
              v-for="restream in restreams"
              :key="restream.id"
            >
              <v-row align="center" class="px-6 py-3">
                <span class="text--secondary">{{ restream.rtmp_url }}</span>
                <v-spacer></v-spacer>
                <v-btn
                  @click="deleteRestream(restream.rtmp_id)"
                  class="mb-1"
                  icon
                  x-small
                  ><v-icon>mdi-close</v-icon></v-btn
                >
              </v-row>
              <v-row class="px-6">
                <v-divider></v-divider>
              </v-row>
            </v-col>
          </v-col>
          <v-card-actions class="px-6 py-5">
            <v-spacer></v-spacer>
            <v-btn text @click="restreamDialog = false">
              {{ $t('message.pages.newLive.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-if="reStreamError">
          <v-card-title class="text-h5">
            <v-icon class="pr-2" large color="primary">mdi-access-point</v-icon>
            {{ $t('message.pages.newLive.reStream') }}
            <v-spacer></v-spacer>
            <v-btn icon @click="closeModal"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            {{ reStreamError }}
          </v-card-text>
          <v-card-actions class="px-6 py-5">
            <v-spacer></v-spacer>
            <v-btn text @click="closeModal">
              {{ $t('message.pages.newLive.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-else-if="reStreamLoading">
          <v-card-title class="text-h5">
            <v-icon class="pr-2" large color="primary">mdi-access-point</v-icon>
            {{ $t('message.pages.newLive.reStream') }}
            <v-spacer></v-spacer>
            <v-btn icon @click="closeModal"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-row justify="center" class="mt-9 mb-8">
            <v-progress-circular
              indeterminate
              :size="72"
              color="primary"
            ></v-progress-circular>
          </v-row>
          <v-card-actions class="px-6 py-5">
            <v-spacer></v-spacer>
            <v-btn text @click="closeModal">
              {{ $t('message.pages.newLive.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
  </span>
</template>

<script>
// external imports

// internal imports

import liveMixin from '@/utils/liveV2.mixin.js'

// API

// Components
import BaseBtn from '@/components/BaseBtn.vue'

export default {
  name: 'LiveKeys',
  components: {
    BaseBtn,
  },
  mixins: [
    liveMixin,
  ],
  data: () => ({
    // ...
  }),
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.w {
  &-100 {
    width: 100%;
  }
}

::v-deep {
  @import '@/assets/scss/src/new-live';
  .v-text-field fieldset,
  .v-text-field .v-input__control {
    border-color: var(--v-neutral-lighten2);
    color: var(--v-neutral-base);
  }
}

.bg-dark {
 
 .page-label {
   color: var(--v-primary-base) !important
 }
}
</style>
